import { Button, styled } from '@nextiva/next-ui-components';

export const StyledBannerButton = styled(Button)`
  border-radius: 2px;
  box-shadow: 0 6.70425px 15.6432px rgba(0, 0, 0, 0.14) !important;
  padding: 16px 18px !important;
`;

export const StyledBannerButtonWhite = styled(StyledBannerButton)`
  background-color: white;
`;

export const StyledBannerButtonDark = styled(StyledBannerButton)`
  background-color: #000a70; // not in story book but used in figma
  color: white !important;
`;
